import { END_POINTS } from "../helpers";
import emptySplitApi from "../utils/rtk";

type CommonResponse = {
  statusCode: number;
  message?: string;
  data?: any;
};
export const portfolioApi = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    addPortfolio: builder.mutation<CommonResponse, any>({
      query: (body) => ({
        url: END_POINTS.portfolios,
        method: "POST",
        body,
      }),
    }),
    updatePortfolio: builder.mutation<
      CommonResponse,
      { id: string; body: any }
    >({
      query: ({ id, body }) => ({
        url: `${END_POINTS.portfoliById}/${id}`,
        method: "PUT",
        body,
      }),
    }),
    getPortfolioList: builder.query<
      CommonResponse,
      { page?: number; limit?: number; search?: string }
    >({
      query: (params) => {
        const newParams: any = { ...params };
        if (!newParams.search) delete newParams.search;
        return {
          url: END_POINTS.portfolioList,
          method: "GET",
          params: newParams,
        }
      },
    }),
    getPortfolioDetails: builder.query<
      CommonResponse,
      { id: string | undefined }
    >({
      query: ({ id }) => ({
        url: `${END_POINTS.portfoliById}/${id}`,
        method: "GET",
      }),
    }),
    deletePortfolio: builder.mutation<CommonResponse, { id: string }>({
      query: ({ id }) => ({
        url: `${END_POINTS.portfoliById}/${id}`,
        method: "DELETE",
      }),
    }),
  }),
});
export const {
  useLazyGetPortfolioListQuery,
  useAddPortfolioMutation,
  useUpdatePortfolioMutation,
  useLazyGetPortfolioDetailsQuery,
  useDeletePortfolioMutation,
} = portfolioApi;
